import { classNames } from '@dimjs/utils';
import { FC } from 'react';
import { Button, ButtonProps } from '../button';
import { Modal, ModalProps } from '../modal';
import './style.less';

export type ModalAlertProps = ModalProps & {
  btnName?: string | JSX.Element;
  onClick?: () => void | Promise<void>;
  buttonProps?: Omit<ButtonProps, 'onClick' | 'stopPropagation'>;
};

export const ModalAlert: FC<ModalAlertProps> = (props) => {
  return (
    <Modal
      closeIcon={false}
      closeByMask={false}
      {...props}
      className={classNames('v-modal-alert', props.className)}
    >
      <div className="v-modal-alert-content">{props.children}</div>
      <div className="v-modal-alert-operate">
        <Button
          fill="none"
          type="primary"
          size="large"
          {...props.buttonProps}
          onClick={props.onClick || props.onClose}
        >
          {props.btnName}
        </Button>
      </div>
    </Modal>
  );
};

ModalAlert.defaultProps = {
  btnName: '确定',
};
